<template>
    <div>
        <div v-if="step == 0" class="monobank-connect-block">
            <div class="left-side-connect">
                <p>
                    {{ $t('monobank_desc_one') }}
                </p>
                <p class="d-none d-sm-block">
                    {{ $t('monobank_desc_two') }}
                </p>
                <p class="d-block d-sm-none">{{ $t('monobank_desc_three') }}</p>
                <p>
                    {{ $t('monobank_desc_four') }}
                </p>
            </div>
            <div class="right-side-connect">
                <div class="qr-code">
                    <a :href="authUrl">
                        <img :src="qrCode" />
                    </a>
                </div>
            </div>
        </div>
        <div v-if="step == 1" class="monobank-accounts-list">
            <div>
                <p>
                    {{ $t('monobank_desc_accounts') }}
                </p>
            </div>
            <div>
                <table class="table table-hover mb-0">
                    <thead>
                        <tr>
                            <th></th>
                            <th>{{ $t('Баланс') }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="account in accounts" :key="account.id">
                            <td>
                                <div class="custom-control custom-checkbox">
                                    <div class="checkbox-group mr-32">
                                        <input :id="`account-${account.id}`" v-model="account.checked" type="checkbox">
                                        <label :for="`account-${account.id}`" class="checkbox-label">
                                            <svg width="30" height="24" viewBox="0 0 39 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="account.maskedPan[0] == '5'">
                                                <path d="M38.6082 19.386V18.9218H38.4868L38.3465 19.2406L38.2068 18.9218H38.0847V19.386H38.171V19.0359L38.3022 19.338H38.3915L38.5227 19.0352V19.386H38.6082ZM37.8383 19.386V19.0009H37.9939V18.9225H37.5972V19.0009H37.7528V19.386H37.8383Z" fill="#F79410"/>
                                                <path d="M24.8127 21.3828H14.3124V2.56079H24.8127V21.3828Z" fill="#FF5F00"/>
                                                <path d="M14.9852 11.9703C14.9852 8.15215 16.7775 4.75106 19.5686 2.55927C17.5275 0.95652 14.9516 -0.000104904 12.1521 -0.000104904C5.52451 -0.000104904 0.1521 5.35913 0.1521 11.9703C0.1521 18.5814 5.52451 23.9407 12.1521 23.9407C14.9516 23.9407 17.5275 22.984 19.5686 21.3813C16.7775 19.1895 14.9852 15.7884 14.9852 11.9703Z" fill="#EB001B"/>
                                                <path d="M38.9744 11.9703C38.9744 18.5814 33.602 23.9407 26.9744 23.9407C24.1749 23.9407 21.599 22.984 19.5571 21.3813C22.349 19.1895 24.1413 15.7884 24.1413 11.9703C24.1413 8.15216 22.349 4.75107 19.5571 2.55928C21.599 0.95653 24.1749 -9.53674e-05 26.9744 -9.53674e-05C33.602 -9.53674e-05 38.9744 5.35914 38.9744 11.9703Z" fill="#F79E1B"/>
                                            </svg>
                                            <svg width="30" height="23" viewBox="0 0 70 23" fill="none" xmlns="http://www.w3.org/2000/svg" v-else>
                                                <g clip-path="url(#clip0)">
                                                    <path d="M30.3333 22.6682H24.6628L28.2095 0.403564H33.8797L30.3333 22.6682Z" fill="#00579F"/>
                                                    <path d="M50.8893 0.947893C49.7709 0.4974 47.9969 0 45.8033 0C40.2035 0 36.2602 3.03162 36.236 7.36592C36.1895 10.5638 39.0593 12.3399 41.2057 13.4062C43.3996 14.4957 44.1453 15.2069 44.1453 16.1781C44.123 17.6696 42.3726 18.3572 40.74 18.3572C38.4761 18.3572 37.263 18.0027 35.4196 17.1729L34.6729 16.8171L33.8794 21.8151C35.2093 22.4302 37.6596 22.9761 40.2035 23C46.1534 23 50.027 20.0153 50.0729 15.3964C50.0955 12.8619 48.5801 10.9198 45.3131 9.33285C43.3298 8.31413 42.1152 7.62721 42.1152 6.58488C42.1385 5.6373 43.1425 4.66674 45.3813 4.66674C47.2248 4.6192 48.5792 5.06907 49.6053 5.51925L50.1181 5.75567L50.8893 0.947893Z" fill="#00579F"/>
                                                    <path d="M58.4259 14.7806C58.8929 13.5015 60.6898 8.55116 60.6898 8.55116C60.6663 8.59869 61.1559 7.24847 61.4359 6.41958L61.8322 8.33803C61.8322 8.33803 62.906 13.6674 63.1392 14.7806C62.2529 14.7806 59.5459 14.7806 58.4259 14.7806ZM65.4254 0.403564H61.0393C59.6867 0.403564 58.6591 0.805891 58.0755 2.25087L49.6527 22.6679H55.6026C55.6026 22.6679 56.5821 19.9199 56.7927 19.328C57.4454 19.328 63.2334 19.328 64.0731 19.328C64.2359 20.1097 64.7497 22.6679 64.7497 22.6679H70.0001L65.4254 0.403564Z" fill="#00579F"/>
                                                    <path d="M19.9266 0.403564L14.3733 15.5859L13.7665 12.5067C12.7398 8.9538 9.51988 5.0936 5.92664 3.17421L11.0132 22.6446H17.0096L25.9227 0.403564H19.9266Z" fill="#00579F"/>
                                                    <path d="M9.2166 0.403564H0.0933346L0 0.853427C7.11672 2.70105 11.83 7.15466 13.7664 12.5077L11.7832 2.27511C11.4566 0.853113 10.4532 0.450471 9.2166 0.403564Z" fill="#FAA61A"/>
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0">
                                                        <rect width="70" height="23" fill="white"/>
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                            <span class="monobank-masked-pan">{{ account.maskedPan }}</span>
                                        </label>
                                    </div>
                                </div>
                            </td>
                            <td v-html="`${$options.filters.money(account.balance)} ${$options.filters.currency(account.currencyCode)}`"></td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td colspan="2">
                                <div class="account-list-table-footer">
                                    <span class="mr-5 ">{{ $t('monobank_desc_load') }}</span>
                                    <button class="btn btn-blue" @click="store">{{ $t('Далее') }}</button>
                                </div>
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
        <div v-if="step == 2" class="monobank-disabled-block">
            <div class="left-side-disable">
                <p>
                    {{ $t('Мы уже выгружаем операции по вашим счетам Монобанка') }}
                </p>

                <div class="btn-group">
                    <button class="btn btn-blue" @click.prevent="disconnect">{{ $t('Хочу отключить') }}</button>
                </div>
            </div>
            <div class="right-side-disable">
                <img style="max-width: 300px" src="@/assets/images/mono-cat.jpg">
            </div>
        </div>
    </div>
</template>

<script>
import { EventBus } from '../../../../event-bus';

export default {
    data: function() {
        return {
            authUrl: null,
            step: 0,

            accounts: [],

            fetchInterval: null,
        };
    },

    computed: {
        allSelected() {
            return this.accounts.filter((account) => account.checked).length == this.accounts.length;
        },

        qrCode() {
            return `${axios.defaults.baseURL}qrcode?url=${this.authUrl}`;
        }
    },

    mounted() {
        this.fetchIntegrationStatus()
            .then((step) => {
                if(step == 0) {
                    this.getAuthUrl();
                }

                if(step == 1) {
                    this.getUserAccounts();
                }
            });
    },

    methods: {
        toggleAll() {
            alert('13');
        },

        getAuthUrl() {
            axios.post('/settings/integration/monobank/auth')
                .then(({data}) => {
                    this.authUrl = data.data.url;
                    
                    this.fetchInterval = setInterval(this.fetchIntegrationStatus, 2000);
                }).catch(({response}) => {
                    console.log(response);

                    return EventBus.$emit('show-alert', response.data.message ? response.data.message : $t('Не удалось получить адрес авторизации'), 'error');
                });
        },

        fetchIntegrationStatus(force = false) {
            if(this.step !== 0 && force == false) {
                return new Promise((resolve) => resolve(null));
            }

            return new Promise((resolve, reject) => {
                axios.get('/settings/integration/monobank/status')
                    .then(({data}) => {
                        if(this.step == 0 && data.data.step == 1) {
                            this.getUserAccounts();
                        }
                        
                        this.step = data.data.step;

                        resolve(this.step);
                    }).catch(({response}) => {
                        console.log(response);

                        return EventBus.$emit('show-alert', response.data.message ? response.data.message : $t('Невозможно получить статус'), 'error');
                    });
            });
        },

        getUserAccounts() {
            axios.get('/settings/integration/monobank/accounts')
                .then(({data}) => {
                    this.accounts = data.data;
                }).catch(({response}) => {
                    console.log(response);

                    return EventBus.$emit('show-alert', response.data.message ? response.data.message : $t('Невозможно получить счета'), 'error');
                });
        },

        disconnect() {
            this.$ga.event('disconnectMonobank', 'clicked');

            if(! confirm('Вы точно хотите отключить интеграцию с Монобанк?')) {
                return;
            }

            axios.delete('/settings/integration/monobank')
                .then(({data}) => {
                    this.fetchIntegrationStatus(true);
                    this.getAuthUrl();

                    this.$ga.event('disconnectMonobank', 'disconnected');
                }).catch(({response}) => {
                    console.log(response);

                    return EventBus.$emit('show-alert', response.data.message ? response.data.message : $t('Неизвестная ошибка'), 'error');
                });
        },

        store() {
            axios.post('/settings/integration/monobank/accounts', {accounts: this.accounts})
                .then(({data}) => {
                    if(data.status == 'success') {
                        this.step = 2;

                        this.$ga.event('connectMonobank', 'useAccounts');
                    }
                }).catch(({response}) => {
                    console.log(response);

                    return EventBus.$emit('show-alert', response.data.message ? response.data.message : $t('Неизвестная ошибка'), 'error');
                });
        }
    },

    beforeDestroy() {
        clearInterval(this.fetchInterval);
    }
}
</script>

<style lang="scss" scoped>
.monobank-connect-block {
    display: flex;
    align-items: flex-start;
    margin-top: 15px;
    gap: 10px;

    .left-side-connect {
        width: 50%;

        p {
            margin-top: 0;
        }
    }

    .right-side-connect {
        margin-left: auto;
        width: calc(50% - 45px);

        img {
            width: 100%;
        }
    }
}

.monobank-accounts-list {
    p {
        margin-bottom: 0;
    }

    .monobank-masked-pan {
        margin-left: 5px;
    }

    .table {
        width: 100%;
        margin-bottom: 1rem;
        color: #212529;
        border-collapse: collapse;
        
        tbody {
            tr {
                &:hover {
                    color: #212529;
                    background-color: rgba(0,0,0,.075);
                }
            }
        }

        td, th {
            text-align: inherit;

            padding: 0.75rem;
            vertical-align: top;
            border-top: 1px solid #dee2e6;
        }

        th {
            vertical-align: bottom;
            border-bottom: 2px solid #dee2e6;
            border-top: 0;
        }

        .account-list-table-footer {
            display: flex;
            align-items: center;

            span {
                font-size: 12px;
                font-family: 'Proxima Nova Rg';
                color: rgba(#152640, .5);
            }

            .btn {
                margin-left: auto;
            }
        }
    }
}

.monobank-disabled-block {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;

    .left-side-disable {
        width: 50%;
        text-align: center;
    }

    .right-side-disable {
        width: 50%;
    }
}
</style>